import { COLLECTION_ITEM_APPEARS_IN } from '@annunciate/query/dist/queries/collectionItem';
import { useQuery } from './base';
export const useCollectionItemAppearsInQuery = ({ type, id, }) => {
    return useQuery(['collectionItemAppearsIn'], COLLECTION_ITEM_APPEARS_IN, { type, id });
};
//# sourceMappingURL=useCollectionItemAppearsInQuery.js.map